import { Box, Typography } from '@mui/material';

import {
  ClinicPayerConnectionsView,
  type ClinicPayerConnectionsViewProps,
} from './ClinicPayerConnectionsView';

type AdminPayerConnectionsViewProps = Omit<
  ClinicPayerConnectionsViewProps,
  'onStediLinkClick' | 'onFirstClaimLinkClick' | 'claimReviewNotice'
>;

const noop = () => undefined;

/** Clinic presentation; claim review stays explanatory until staff can open scoped claims. */
export function AdminPayerConnectionsView(props: AdminPayerConnectionsViewProps) {
  return (
    <Box
      component="section"
      aria-label="Payer connections"
      sx={{ p: { xs: 2, md: 3 }, bgcolor: 'background.paper' }}
    >
      <Typography component="h2" variant="h6">
        Payer connections
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Viewing as the clinic sees it
      </Typography>
      <ClinicPayerConnectionsView
        {...props}
        onStediLinkClick={noop}
        onFirstClaimLinkClick={noop}
        claimReviewNotice="The clinic can review claims in JotBill."
      />
    </Box>
  );
}
